"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalStatuses = exports.StatusIterables = exports.toMeshDocumentMetadata = exports.generateMeshRunId = exports.generateMeshDocumentId = exports.readMeshId = exports.readMeshRunId = exports.readMeshDocumentId = exports.isMeshId = void 0;
const isMeshId = (id) => {
    return id.includes('_');
};
exports.isMeshId = isMeshId;
const readMeshDocumentId = (meshDocumentId) => {
    const [artifactDocumentId, meshArtifactId] = meshDocumentId.split('_');
    return { artifactDocumentId, meshArtifactId };
};
exports.readMeshDocumentId = readMeshDocumentId;
const readMeshRunId = (meshRunId) => {
    const [pipelineRunId, meshArtifactId] = meshRunId.split('_');
    return { pipelineRunId, meshArtifactId };
};
exports.readMeshRunId = readMeshRunId;
const readMeshId = (meshId) => {
    const [_unused, meshArtifactId] = meshId.split('_');
    return { meshArtifactId };
};
exports.readMeshId = readMeshId;
const generateMeshDocumentId = ({ artifactDocumentId, meshArtifactId, }) => {
    return `${artifactDocumentId}_${meshArtifactId}`;
};
exports.generateMeshDocumentId = generateMeshDocumentId;
const generateMeshRunId = ({ pipelineRunId, meshArtifactId, }) => {
    return `${pipelineRunId}_${meshArtifactId}`;
};
exports.generateMeshRunId = generateMeshRunId;
const toMeshDocumentMetadata = (meshDocument) => {
    const { borrowerOrganizationId, implementationId, meshDocumentId, cfSlugs, lpSlugs, meshName, } = meshDocument;
    return {
        borrowerOrganizationId,
        implementationId,
        meshDocumentId,
        cfSlugs,
        lpSlugs,
        meshName,
    };
};
exports.toMeshDocumentMetadata = toMeshDocumentMetadata;
exports.StatusIterables = [
    'error',
    'success',
    // this is a special status that is determined at higher level (not in mesh)
    // that is mesh run may report a datapipeline as inProgress, but at higher level
    // we may determine that it is expired. since another mesh run happened since then.
    // or graph changed since then.
    'expired',
    // in progress statuses
    'inProgress',
    'waitingForInput',
    'waitingForAssignment',
    'waitingForVerificationApproval',
];
exports.TerminalStatuses = ['error', 'success', 'expired'];
//# sourceMappingURL=DataPipeline.js.map